export const constant = {
  admin: ["admin"],
  merchant: "merchant",
  merchantRole: "merchant",
  CustomerServiceAdmin: ["customerServiceAdmin"],
  adminRole: "admin",
  customerRole: "customer",
  CustomerServiceAdminRole: ["customerServiceAdmin"],
  domain: "", 
  modules: {
    sales: "sale_of_voucher",
    memberRedemption: "Member Redemption",
  },
};
